import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IClinicRepository from '../../2_domain/clinic/iClinicRepository';
import { NoticeSummary } from '../../2_domain/notice/notice';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const useNoticeListPageController = () => {
  const clinicRepo = Get.find<IClinicRepository>('IClinicRepository');

  const navigate = useNavigate();

  const [notices, setNotices] = useState<NoticeSummary[]>([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalNotices, setTotalNotices] = useState(0);
  const pageSize = 10;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadNotice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  const loadNotice = async () => {
    await promiseResolver({
      promise: clinicRepo.getClinicNotices({
        pageNumber: pageNumber,
        pageSize: pageSize,
        isAscending: true,
      }),
      successCallback: (data) => {
        setNotices(data.list);
        setTotalNotices(data.page.totalElements);
      },
      isLoadingCallback: setIsLoading,
    });
  };

  const onPageNumberChagne = (newPageNumber: number) => {
    setPageNumber(newPageNumber);
  };

  const onNoticeClickHandler = (target: NoticeSummary) => {
    navigate(`../notice/${target.id}`);
  };

  return {
    notices,
    pageNumber,
    onPageNumberChagne,
    totalNotices,
    pageSize,
    isLoading,
    onNoticeClickHandler,
  };
};

export default useNoticeListPageController;
